import React from "react";
import { Link } from "react-router-dom";
import { Mail, Phone, MapPin } from "lucide-react";

export default function Footer({ profile }) {
  return (
    <footer data-testid="site-footer" className="bg-[#1A2456] text-[#F5EFE6] mt-24">
      <div className="chevron-divider" style={{ opacity: 0.5 }} />
      <div className="max-w-7xl mx-auto px-6 sm:px-8 lg:px-12 py-16 grid md:grid-cols-3 gap-10">
        <div>
          <h3 className="font-serif-display text-2xl font-semibold text-white">
            {profile?.name || "Dr. Ruchi Singh"}
          </h3>
          <p className="text-[10px] tracking-[0.3em] uppercase text-[#E35D29] mt-1">
            {profile?.title || "Assistant Professor"}
          </p>
          <p className="mt-4 text-sm text-[#EAE0D5] leading-relaxed max-w-xs">
            Academic research and community extension work rooted in the soil of Madhya Pradesh, India.
          </p>
        </div>

        <div>
          <h4 className="text-xs tracking-[0.25em] uppercase text-[#E35D29] mb-4">Explore</h4>
          <ul className="space-y-2 text-sm">
            {["About", "Research", "Activities", "Publications", "Gallery", "Blog"].map((x) => (
              <li key={x}>
                <Link
                  data-testid={`footer-link-${x.toLowerCase()}`}
                  className="hover:text-[#E35D29] transition-colors"
                  to={`/${x.toLowerCase()}`}
                >
                  {x}
                </Link>
              </li>
            ))}
          </ul>
        </div>

        <div>
          <h4 className="text-xs tracking-[0.25em] uppercase text-[#E35D29] mb-4">Contact</h4>
          <ul className="space-y-3 text-sm text-[#EAE0D5]">
            {profile?.email && (
              <li className="flex items-start gap-3">
                <Mail size={16} className="mt-1 text-[#E35D29]" />
                <span>{profile.email}</span>
              </li>
            )}
            {profile?.phone && (
              <li className="flex items-start gap-3">
                <Phone size={16} className="mt-1 text-[#E35D29]" />
                <span>{profile.phone}</span>
              </li>
            )}
            {profile?.address && (
              <li className="flex items-start gap-3">
                <MapPin size={16} className="mt-1 text-[#E35D29]" />
                <span>{profile.address}</span>
              </li>
            )}
          </ul>
        </div>
      </div>
      <div className="border-t border-white/10">
        <div className="max-w-7xl mx-auto px-6 sm:px-8 lg:px-12 py-6 flex flex-col sm:flex-row justify-between items-center text-xs text-[#B9B0A5]">
          <p>© {new Date().getFullYear()} Dr. Ruchi Singh. All rights reserved.</p>
          <Link data-testid="admin-portal-link" to="/admin" className="hover:text-[#E35D29] transition-colors">
            Admin Portal
          </Link>
        </div>
      </div>
    </footer>
  );
}
